export const lessonsData = [
  {
    dayOfWeek: 'Monday',
    lessonDate: '2020-09-07',
    lessons: [
      {
        teachingOrderLessonId: 106,
        lessonId: 98,
        pageId: 888,
        title: 'Get Ready! Posture, Paper & Grip',
        page: {
          id: 888,
          bookId: 8,
          pageNumber: 33
        },
        sections: []
      }
    ]
  },
  {
    assigned: true,
    dayOfWeek: 'Tuesday',
    lessonDate: '2020-09-08',
    lessons: [
      {
        teachingOrderLessonId: 111,
        lessonId: 101,
        pageId: 3633,
        title: 'Frog Jump Letters',
        page: {
          id: 3633,
          bookId: 8,
          pageNumber: 46
        },
        assigned: true,
        sections: [
          {
            id: 289,
            title: 'Warm Up',
            activities: [
              {
                id: 364,
                resourceId: 327,
                resourceTypeId: 4,
                title: 'Frog Jump Capitals F',
                duration: 1,
                type: {
                  id: 4,
                  type: 'animation',
                  title: 'Animations',
                  icon:
                    'https://hwt-educator-content-qa.s3.amazonaws.com/icons/AnimationVideo_v2.svg'
                },
                url:
                  'https://hwt-educator-content-qa.s3.amazonaws.com/animations/en-us/Frog_Jump_Capitals_F_092117.mp4',
                data: {
                  mediaType: 'video',
                  fileExtension: 'mp4',
                  src: 'en-us/Frog_Jump_Capitals_F_092117.mp4'
                }
              },
              {
                id: 365,
                resourceId: 16,
                resourceTypeId: 5,
                title: 'Frog Jump Letters',
                duration: 2,
                type: {
                  id: 5,
                  type: 'music',
                  title: 'Music',
                  icon: 'https://hwt-educator-content-qa.s3.amazonaws.com/icons/Music_v2.svg'
                },
                url:
                  'https://hwt-educator-content-qa.s3.amazonaws.com/music/rock-rap-tap-learn/en-us/12-Frog-Jump-Letters.mp3',
                data: {
                  mediaType: 'audio',
                  fileExtension: 'mp3',
                  src: 'rock-rap-tap-learn/en-us/12-Frog-Jump-Letters.mp3'
                }
              }
            ]
          },
          {
            id: 290,
            title: 'Demo & Practice',
            activities: [
              {
                id: 366,
                resourceId: 403,
                resourceTypeId: 6,
                title: 'Positions and Body Parts',
                duration: 5,
                type: {
                  id: 6,
                  type: 'video',
                  title: 'Teaching Videos',
                  icon:
                    'https://hwt-educator-content-qa.s3.amazonaws.com/icons/TeacherLedLessons_v2.svg'
                },
                url:
                  'https://hwt-educator-content-qa.s3.amazonaws.com/videos/en-us/Positions_and_body_parts_120117.mp4',
                data: {
                  mediaType: 'video',
                  fileExtension: 'mp4',
                  src: 'en-us/Positions_and_body_parts_120117.mp4'
                }
              },
              {
                id: 367,
                pageId: 9,
                bookId: 2,
                pageNumber: 8,
                duration: 5,
                title: 'Letters and Numbers for Me, p. 8',
                url: 'https://qa01-idtt-2022.lwtears.com/books/LN/2018/8/zoom',
                type: {
                  type: 'workbookPage',
                  title: 'Student Edition page',
                  icon:
                    'https://hwt-educator-content-qa.s3.amazonaws.com/icons/student-workbook.svg'
                }
              }
            ]
          },
          {
            id: 291,
            title: 'Extras',
            activities: [
              {
                id: 368,
                resourceId: 464,
                resourceTypeId: 7,
                title: 'Our World - Tadpole',
                duration: 1,
                type: {
                  id: 7,
                  type: 'ourWorld',
                  title: 'Our World Videos',
                  icon: 'https://hwt-educator-content-qa.s3.amazonaws.com/icons/WorldVideo_v2.svg'
                },
                url:
                  'https://hwt-educator-content-qa.s3.amazonaws.com/our-world/en-us/Our_World_Tadpole_121417.mp4',
                data: {
                  mediaType: 'video',
                  fileExtension: 'mp4',
                  src: 'en-us/Our_World_Tadpole_121417.mp4'
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    dayOfWeek: 'Wednesday',
    lessonDate: '2020-09-09',
    lessons: [
      {
        teachingOrderLessonId: 107,
        lessonId: 99,
        pageId: 3632,
        title: 'Help Me Write My Name',
        page: {
          id: 3632,
          bookId: 8,
          pageNumber: 45
        },
        sections: [
          {
            id: 283,
            title: 'Warm Up',
            activities: [
              {
                resourceId: 335,
                resourceTypeId: 4,
                title: 'Grip',
                duration: 1,
                type: {
                  id: 4,
                  type: 'animation',
                  title: 'Animations',
                  icon:
                    'https://hwt-educator-content-qa.s3.amazonaws.com/icons/AnimationVideo_v2.svg'
                },
                url:
                  'https://hwt-educator-content-qa.s3.amazonaws.com/animations/en-us/grip_091317.mp4',
                data: {
                  mediaType: 'video',
                  fileExtension: 'mp4',
                  src: 'en-us/grip_091317.mp4'
                }
              },
              {
                resourceId: 6,
                resourceTypeId: 5,
                title: 'Where Do you Start your Letters',
                duration: 2,
                type: {
                  id: 5,
                  type: 'music',
                  title: 'Music',
                  icon: 'https://hwt-educator-content-qa.s3.amazonaws.com/icons/Music_v2.svg'
                },
                url:
                  'https://hwt-educator-content-qa.s3.amazonaws.com/music/rock-rap-tap-learn/en-us/02-Where-Do-You-Start-Your-Letters.mp3',
                data: {
                  mediaType: 'audio',
                  fileExtension: 'mp3',
                  src: 'rock-rap-tap-learn/en-us/02-Where-Do-You-Start-Your-Letters.mp3'
                }
              }
            ]
          },
          {
            id: 284,
            title: 'Demo & Practice',
            activities: [
              {
                resourceId: 925,
                resourceTypeId: 6,
                title: 'Classroom Lesson: Where Do You Start Your Letters?',
                duration: 5,
                type: {
                  id: 6,
                  type: 'video',
                  title: 'Teaching Videos',
                  icon:
                    'https://hwt-educator-content-qa.s3.amazonaws.com/icons/TeacherLedLessons_v2.svg'
                },
                url:
                  'https://hwt-educator-content-qa.s3.amazonaws.com/videos/en-us/CrowdSource_Melissa_McHugh_Where_do_You_Start_Your_Letters_091718.mp4',
                data: {
                  mediaType: 'video',
                  fileExtension: 'mp4',
                  src: 'en-us/CrowdSource_Melissa_McHugh_Where_do_You_Start_Your_Letters_091718.mp4'
                }
              },
              {
                pageId: 8,
                bookId: 2,
                pageNumber: 7,
                duration: 5,
                title: 'Letters and Numbers for Me, p. 7',
                url: 'https://qa01-idtt-2022.lwtears.com/books/LN/2018/7/zoom',
                type: {
                  type: 'workbookPage',
                  title: 'Student Edition page',
                  icon:
                    'https://hwt-educator-content-qa.s3.amazonaws.com/icons/student-workbook.svg'
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    dayOfWeek: 'Thursday',
    lessonDate: '2020-09-10',
    lessons: [
      {
        teachingOrderLessonId: 108,
        lessonId: 98,
        pageId: 888,
        title: 'Get Ready! Posture, Paper & Grip',
        page: {
          id: 888,
          bookId: 8,
          pageNumber: 33
        },
        sections: []
      }
    ]
  },
  {
    dayOfWeek: 'Friday',
    lessonDate: '2020-09-11',
    lessons: [
      {
        teachingOrderLessonId: 109,
        lessonId: 99,
        pageId: 3632,
        title: 'Help Me Write My Name',
        page: {
          id: 3632,
          bookId: 8,
          pageNumber: 45
        },
        sections: [
          {
            id: 283,
            title: 'Warm Up',
            activities: [
              {
                resourceId: 335,
                resourceTypeId: 4,
                title: 'Grip',
                duration: 1,
                type: {
                  id: 4,
                  type: 'animation',
                  title: 'Animations',
                  icon:
                    'https://hwt-educator-content-qa.s3.amazonaws.com/icons/AnimationVideo_v2.svg'
                },
                url:
                  'https://hwt-educator-content-qa.s3.amazonaws.com/animations/en-us/grip_091317.mp4',
                data: {
                  mediaType: 'video',
                  fileExtension: 'mp4',
                  src: 'en-us/grip_091317.mp4'
                }
              },
              {
                resourceId: 6,
                resourceTypeId: 5,
                title: 'Where Do you Start your Letters',
                duration: 2,
                type: {
                  id: 5,
                  type: 'music',
                  title: 'Music',
                  icon: 'https://hwt-educator-content-qa.s3.amazonaws.com/icons/Music_v2.svg'
                },
                url:
                  'https://hwt-educator-content-qa.s3.amazonaws.com/music/rock-rap-tap-learn/en-us/02-Where-Do-You-Start-Your-Letters.mp3',
                data: {
                  mediaType: 'audio',
                  fileExtension: 'mp3',
                  src: 'rock-rap-tap-learn/en-us/02-Where-Do-You-Start-Your-Letters.mp3'
                }
              }
            ]
          },
          {
            id: 284,
            title: 'Demo & Practice',
            activities: [
              {
                resourceId: 925,
                resourceTypeId: 6,
                title: 'Classroom Lesson: Where Do You Start Your Letters?',
                duration: 5,
                type: {
                  id: 6,
                  type: 'video',
                  title: 'Teaching Videos',
                  icon:
                    'https://hwt-educator-content-qa.s3.amazonaws.com/icons/TeacherLedLessons_v2.svg'
                },
                url:
                  'https://hwt-educator-content-qa.s3.amazonaws.com/videos/en-us/CrowdSource_Melissa_McHugh_Where_do_You_Start_Your_Letters_091718.mp4',
                data: {
                  mediaType: 'video',
                  fileExtension: 'mp4',
                  src: 'en-us/CrowdSource_Melissa_McHugh_Where_do_You_Start_Your_Letters_091718.mp4'
                }
              },
              {
                pageId: 8,
                bookId: 2,
                pageNumber: 7,
                duration: 5,
                title: 'Letters and Numbers for Me, p. 7',
                url: 'https://qa01-idtt-2022.lwtears.com/books/LN/2018/7/zoom',
                type: {
                  type: 'workbookPage',
                  title: 'Student Edition page',
                  icon:
                    'https://hwt-educator-content-qa.s3.amazonaws.com/icons/student-workbook.svg'
                }
              }
            ]
          }
        ]
      }
    ]
  }
];
